var render, staticRenderFns
import script from "./date-table.vue?vue&type=script&lang=js&"
export * from "./date-table.vue?vue&type=script&lang=js&"
import style0 from "./date-table.vue?vue&type=style&index=0&id=2c4ad65c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4ad65c",
  null
  
)

export default component.exports